<template>
    <div class="select-page-section" :class="{retract:retracted}">
        <div class="header-select-page-section">
            <div class="chevron">
                <i class="fa-solid fa-chevron-left" @click="toggleStateRetracted"></i>
            </div>
            <h4>{{ $t(titleKey) }}</h4>
        </div>
       

        <div class="container-select-page">

            <div class="skeleton-loader" v-if="!pageLoaded">
                <div v-for="n in 10">
                    <VueSkeletonLoader
                        type="circle"
                        :width="35"
                        :height="35"
                        animation="fade"
                        wave-color="rgba(255, 255, 255, 0.3)"
                    />
                    <VueSkeletonLoader
                        v-if="!retracted"
                        type="rect"
                        :width="140"
                        :height="18"
                        :rounded="1"
                        :radius="4"
                        animation="wave"
                        wave-color="rgba(255, 255, 255, 0.3)"
                    />
                </div>
              
            </div>

            <SelectPage
                v-show="pageLoaded"
                :id="'selectPageSection'"
                :groups="filteredGroups"
                :allPages="filteredAllPages"
                :SelectPageProp="pagesSelected"
                :forceOpenAllGroups="retracted"
                :isFreezed="freeze"
                @updateSelectPage="updateSelectPage"
            >
                <template #between-search-and-list>
                    <slot name="between-search-and-list"></slot>
                </template>
            </SelectPage>

            
        </div>
       
    </div>
</template>

<script>
    import store from './../../store/index.js';
    import { EventBus } from '@/event-bus';
    import SelectPage from './SelectPage.vue';
    import VueSkeletonLoader from 'skeleton-loader-vue';
    export default {
        components: {
            SelectPage,
            VueSkeletonLoader
        },

        props: {
            hide: Boolean,
            titleKey: { type: String, default: 'dash.select_page_section.publications' },
            filterNetworks: { type: Array, default: () => [] },
            filterFn: { type: Function, default: null },
        },

        data() {
            return {
              freeze: false
            }
        },

        mounted () {
           EventBus.$on('selectPageSection/freezeSelectPage', this.freezeSelectPage);
        },

        watch: {
            pageLoaded: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (this.pageLoaded && this.pagesSelected.length === 0) {
                        const firstPageId = Object.keys(this.allPages)[0];
                        if (firstPageId) {
                            this.updateSelectPage([firstPageId]);
                        }
                    }
                }
            }
        },
      
        methods: {
            updateSelectPage(pagesId) {
                console.log('updateSelectPage',pagesId)
                pagesId = pagesId.filter(id => this.allPages[id])
                this.$store.commit('selectPage/updatePagesSelected', {pagesId});
                // localStorage.setItem('selectPage/PageSelected',JSON.stringify(pagesId))
            },
            toggleStateRetracted() {
                this.$store.commit('selectPage/updateSelectPageListRetracted', !this.retracted);
            },
            freezeSelectPage(freeze) {
                this.freeze = freeze;
            }
        },

        computed: {
            groups() {
                return this.$store.getters['selectPage/selectPageGroups'];
            },
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            filteredAllPages() {
                let entries = Object.entries(this.allPages)
                if (this.filterNetworks.length) {
                    entries = entries.filter(([, p]) => this.filterNetworks.includes(p.network))
                }
                if (this.filterFn) {
                    entries = entries.filter(([, p]) => this.filterFn(p))
                }
                return Object.fromEntries(entries)
            },
            filteredGroups() {
                if (!this.filterNetworks.length && !this.filterFn) return this.groups;
                const result = {};
                Object.entries(this.groups).forEach(([id, group]) => {
                    const pages = (group.pages || []).filter(pid => this.filteredAllPages[pid]);
                    if (pages.length) result[id] = Object.assign({}, group, { pages });
                });
                return result;
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected']
                    .filter(id => this.filteredAllPages[id])
                    .map(id => this.filteredAllPages[id]);
            },
            retracted() {
                return this.$store.getters['selectPage/selectPageStateListRetracted'];
            },

            pageLoaded() {
                return this.$store.getters['selectPage/isInit'];
            }

            
           

        },

        beforeDestroy () {
            EventBus.$off('selectPageSection/freezeSelectPage', this.freezeSelectPage);
        },
    }
</script>

